import qrCodePublishedSitePanel from './qrCodePublishedSitePanel/qrCodePublishedSitePanel';
import advancedMenusMigrationPanel from './advancedMenusMigrationPanel/advancedMenusMigrationPanel';
import optionalSectionsMigrationPanel from './optionalSectionsMigrationPanel/optionalSectionsMigrationPanel';

export {
  qrCodePublishedSitePanel,
  advancedMenusMigrationPanel,
  optionalSectionsMigrationPanel,
};
